/**
 * Global JS
 */

// Vendors
import styles from '../scss/global.scss';
import $ from 'jquery';
import './lib/bootstrap';
import 'slick-carousel/slick/slick.js';
import 'fancybox/dist/js/jquery.fancybox.pack';
import 'jquery.scrollto/jquery.scrollTo.min';
import 'jquery.localscroll/jquery.localScroll.min';
import 'waypoints/lib/jquery.waypoints.min';
import './lib/wl-sticky';
import './lib/wl-dynamic-subnav';
import './lib/wl-share';

// Components
import './components/back-to-top';
import './components/nav-mobile';
import './components/nav-sidebar';
import './components/panel-groups';
import './components/sidebar';
import './components/utilities';



// WEBPACK FOOTER //
// ./assets/js/global.js